import e from"./toPropertyKey.js";function r(r,t,o){return(t=e(t))in r?Object.defineProperty(r,t,{value:o,enumerable:!0,configurable:!0,writable:!0}):r[t]=o,r}export{r as default};
//# sourceMappingURL=defineProperty.js.map
